import React from 'react'
import ITPDiagram from "./ITPDiagram";

const ResultSeparated = ({ assessment, item, title, page_number }) => (
    <div className="KeyImplications px-12 pt-4 mb-12">

        <h2 className="text-25 font-bold my-12">
            Key Implications
        </h2>

        {/* ─── Two-column: Heading & Text ─── Diagram ───────────────────── */}
        <div className="grid grid-cols-3 gap-8">
            {/* Left */}
            <div className="col-span-2">
                <h3 className="text-[11pt] font-bold uppercase">
                    {title}
                </h3>
                <p className={'text-[10pt]'}>{item?.text}</p>
            </div>

            <div className="flex items-start -mt-8 h-auto">
                <ITPDiagram
                    textHumble={item?.textHumble}
                    textHungry={item?.textHungry}
                    textSmart={item?.textSmart}
                    strokeColor="#000"
                    strokeWidth={'2.5px'}
                    fillHungry={item?.fillHungry || '#fff'}
                    fillSmart={item?.fillSmart || '#fff'}
                    fillHumble={item?.fillHumble || '#fff'}
                    titleTextSize={'18pt'}
                    subtitleTextSize={'15pt'}
                    smartYPaddingOffset={20}
                    hungryYPaddingOffset={35}
                    humbleYPaddingOffset={35}
                    smartRotPaddingOffset={0}
                    hungryRotPaddingOffset={58}
                    humbleRotPaddingOffset={58}
                />
            </div>
        </div>

        {/* ─── Divider ───────────────────────────────────────────────────── */}
        <hr />

        {/* ─── Susceptible Behaviors Intro ─────────────────────────────── */}
        <p className="font-semibold text-[9pt] mb-4">
            {item?.descriptionTitle}
        </p>

        {/* ─── Behaviors List ───────────────────────────────────────────── */}
        <ul className="space-y-4 text-[9pt] leading-none mr-24">
            {item.behaviors.map((behaviour, i) => (
                <li key={i} className="flex">
                    <span className="bullet-itp"></span>
                    <div className="ml-3 mr-18 leading-normal">
                        <span className="font-semibold">{behaviour.title}:</span> {behaviour.description}
                    </div>
                </li>
            ))}
        </ul>
    </div>
);

export default ResultSeparated;
